// Web Push подписка виджета: ответ ассистента догоняет посетителя, даже если
// вкладка закрыта (порт механики marketpult site_chat). Работает только там,
// где /widget-sw.js раздаётся с origin ХОСТ-страницы — веб-стандарт запрещает
// кросс-доменную регистрацию воркера: на нашем лендинге — из коробки, чужой
// сайт кладёт файл к себе в корень. Нет файла / поддержки / разрешения —
// тихий no-op: пуш — любезность, ответ и так приедет поллингом ленты.
import { WidgetApi } from './api';

const SW_PATH = '/widget-sw.js';

/** Сигнал сервис-воркера «клик по нотификации» — хозяин просит открыть чат
 *  в уже сфокусированной вкладке (см. public/widget-sw.js). */
export function onServiceWorkerOpen(callback: () => void): void {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.addEventListener('message', (event: MessageEvent) => {
    const data = event.data as { type?: string } | null;
    if (data?.type === 'assiistent:open') callback();
  });
}

/** Подписка на Web Push. Зовётся ПОСЛЕ первой реплики посетителя (permission
 *  prompt только по жесту: спрошенный на входе — кратчайший путь к вечному
 *  «Блокировать»). Отказал раньше — не переспрашиваем; granted — тихо
 *  освежаем подписку на сервере. */
export async function subscribeToPush(api: WidgetApi, visitorKey: string, vapidKey: string): Promise<void> {
  if (!('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) return;
  if (Notification.permission === 'denied') return;
  try {
    const registration = await navigator.serviceWorker.register(SW_PATH);
    if (Notification.permission === 'default') {
      const answer = await Notification.requestPermission();
      if (answer !== 'granted') return;
    }
    const existing = await registration.pushManager.getSubscription();
    const subscription =
      existing ??
      (await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: vapidBytes(vapidKey),
      }));
    await api.postPushSubscription(visitorKey, subscription.toJSON());
  } catch {
    // Нет файла воркера на этом origin (чужой сайт) / prompt закрыт / сеть —
    // молчим: ответ в любом случае покажет лента чата.
  }
}

/** VAPID-ключ едет base64url-текстом; PushManager хочет сырые байты
 *  (строго поверх ArrayBuffer — требование типа BufferSource в TS 6). */
function vapidBytes(key: string): Uint8Array<ArrayBuffer> {
  const padded = `${key}${'='.repeat((4 - (key.length % 4)) % 4)}`.replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(padded);
  const bytes = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) bytes[i] = raw.charCodeAt(i);
  return bytes;
}
